import { gql } from '@apollo/client';

/* ── queued backend work ────────────────────────────────────── */

/**
 * The work the signed-in user started in the last 24 hours, newest first —
 * every subject when `subject` is null, one portfolio's when it is its symbol.
 *
 * One row per queued run, old runs included. `kind` + `key` identify a run;
 * `kind` + `eventType` say what sort of work it is (config/jobTypes.js).
 *
 * `state` is WAITING or RUNNING while pending, then DONE, FAILED, CANCELLED or
 * UNKNOWN. `cancelled` is set alongside CANCELLED.
 *
 * Read by the background-jobs provider (api/backgroundJobs.js), and screens
 * ask the provider rather than polling this themselves — with one exception.
 * The list is the CALLER's, and the provider asks as the signed-in advisor. A
 * review requested on a client's behalf (`X-Target-User-Id`) is followed by
 * `useRefreshPortfolioReview`, which asks for that one portfolio's events on
 * the same client's behalf.
 */
export const TRIGGERED_EVENTS = gql`
  query TriggeredEvents($subject: String) {
    getTriggeredEvents(subject: $subject) {
      kind
      key
      eventType
      state
      subject
      source
      enqueuedAt
      cancelled
    }
  }
`;
